module.exports = __webpack_public_path__ + "static/media/digital-marketing-introduce-1.f41b48f3.png";